import React, { useState } from 'react';
import { Beer } from 'lucide-react';

const RankingArena = () => {
  const [activeYear, setActiveYear] = useState('2025');
  const [activePhase, setActivePhase] = useState('BOS');

  const allResults = {
    '2025': {
      BOS: [
        { pos: '1°', beer: '6', brewer: 'NICK BUDNITSKY', style: 'Belgian Golden Strong Ale', points: '37', mention: 'MENZIONE SPECIALE' },
        { pos: '2°', beer: '12', brewer: 'DARIO PASINI', style: 'Historical Beer (Rotbier)', points: '43' },
        { pos: '3°', beer: '29', brewer: 'ALESSANDRO CARRARA', style: 'Biere de Garde', points: '39.5' },
        { pos: '4°', beer: '31', brewer: "EMILIANO D'OVIDIO", style: 'Imperial Stout', points: '39' },
        { pos: '5°', beer: '15', brewer: 'LUCA SESTILI', style: 'Fruit Lambic', points: '37' },
        { pos: '6°', beer: '3', brewer: 'CARLO SESIA', style: 'American Barley Wine', points: '44.5' },
      ],
      TAVOLO1: [
        { pos: '1°', beer: '29', brewer: 'ALESSANDRO CARRARA', style: 'Biere de Garde', points: '39.5', final: true },
        { pos: '2°', beer: '31', brewer: "EMILIANO D'OVIDIO", style: 'Imperial Stout', points: '39', final: true },
        { pos: '3°', beer: '2', brewer: 'OSCAR GRILLO', style: 'Best Bitter', points: '36' },
        { pos: '4°', beer: '30', brewer: 'ROBERTO CAPEZZALI', style: 'English IPA', points: '34.5' },
        { pos: '5°', beer: '11', brewer: 'UMBERTO CARTORE', style: 'Imperial Stout', points: '34' },
        { pos: '6°', beer: '13', brewer: 'CRISTIAN MARTELLI', style: 'British Golden Ale', points: '32' },
        { pos: '7°', beer: '14', brewer: 'LUCA SESTILI', style: 'Wood-Aged Beer', points: '31' },
        { pos: '8°', beer: '1', brewer: 'MARIO FRUMENTO', style: 'British Golden Ale', points: '30.5' },
        { pos: '9°', beer: '32', brewer: "EMILIANO D'OVIDIO", style: 'Schwarzbier', points: '28.5' },
        { pos: '10°', beer: '24', brewer: 'DOMENICO CATRAMBONE', style: 'Irish Red Ale', points: '26' },
      ],
      TAVOLO2: [
        { pos: '1°', beer: '15', brewer: 'LUCA SESTILI', style: 'Fruit Lambic', points: '37', final: true },
        { pos: '2°', beer: '6', brewer: 'NICK BUDNITSKY', style: 'Belgian Golden Strong Ale', points: '37', final: true },
        { pos: '3°', beer: '28', brewer: 'ALESSANDRO CARRARA', style: 'Spiced Vegetable Beer', points: '35' },
        { pos: '4°', beer: '27', brewer: 'ALESSANDRO CARRARA', style: 'Belgian Pale Ale', points: '34.5' },
        { pos: '5°', beer: '18', brewer: 'MARCO NODARI', style: 'Belgian Dubbel', points: '33' },
        { pos: '6°', beer: '7', brewer: 'NICK BUDNITSKY', style: 'English Barley Wine', points: '31' },
        { pos: '7°', beer: '21', brewer: 'PAUL NORDHAUS', style: 'Saison', points: '30.5' },
        { pos: '8°', beer: '16', brewer: 'LUCA SESTILI', style: 'German Pils', points: '30.5' },
        { pos: '9°', beer: '8', brewer: 'NICK BUDNITSKY', style: 'Schwarzbier', points: '30' },
      ],
      TAVOLO3: [
        { pos: '1°', beer: '3', brewer: 'CARLO SESIA', style: 'American Barley Wine', points: '44.5', final: true },
        { pos: '2°', beer: '12', brewer: 'DARIO PASINI', style: 'Historical Beer (Rotbier)', points: '43', final: true },
        { pos: '3°', beer: '4', brewer: 'DONATO GRAZIANO', style: 'Hazy IPA', points: '41.5' },
        { pos: '4°', beer: '17', brewer: 'EMANUELE CINTOLO', style: 'Italian Grape Ale', points: '35.5' },
        { pos: '5°', beer: '20', brewer: 'PAUL NORDHAUS', style: 'Belgian Dubbel', points: '32' },
        { pos: '6°', beer: '23', brewer: 'DOMENICO CATRAMBONE', style: 'Saison', points: '28.5' },
        { pos: '7°', beer: '26', brewer: 'ROBERTO NICCOLAI', style: 'Münchner Dunkel', points: '26.5' },
        { pos: '8°', beer: '19', brewer: 'FILIPPO PARICIANI', style: 'German Pils', points: '26' },
        { pos: '9°', beer: '10', brewer: 'CHRISTOPHER OLIVA', style: 'Belgian Dark Strong Ale', points: '25' },
        { pos: '10°', beer: '25', brewer: 'DOMENICO CATRAMBONE', style: 'Alternative Sugar Beer', points: '25' },
        { pos: '11°', beer: '22', brewer: 'PAUL DORDHAUS', style: 'Russian Imperial Stout', points: '16.5' },
      ]
    },
    '2024': {
      BOS: [
        { pos: '1°', beer: '7', brewer: 'ANGELO CASERTA', style: 'English Barley Wine', points: '41.5' },
        { pos: '2°', beer: '17', brewer: 'FILIPPO PARICIANI', style: 'American IPA', points: '36' },
        { pos: '3°', beer: '15', brewer: 'LUCA SESTILI', style: 'Specialty Fruit Beer', points: '41.5' },
        { pos: '4°', beer: '6', brewer: 'CLAUDIO TREMENTOZZI', style: 'American Porter', points: '39' },
        { pos: '5°', beer: '26', brewer: 'DONATO GRAZIANO', style: 'Belgian Blond Ale', points: '37' },
        { pos: '6°', beer: '3', brewer: 'MATTEO MEDDA', style: 'American IPA', points: '33.5' },
      ],
      TAVOLO1: [
        { pos: '1°', beer: '7', brewer: 'ANGELO CASERTA', style: 'English Barley Wine', points: '41.5', final: true },
        { pos: '2°', beer: '15', brewer: 'LUCA SESTILI', style: 'Specialty Fruit Beer', points: '41.5', final: true },
        { pos: '3°', beer: '22', brewer: 'ANTONIO DI FRANCIA', style: 'Imperial Stout', points: '37.5' },
        { pos: '4°', beer: '1', brewer: 'MARINI MARCO', style: 'British Brown Ale', points: '35' },
        { pos: '5°', beer: '14', brewer: 'LUCA SESTILI', style: 'Italian Pils', points: '33' },
        { pos: '6°', beer: '9', brewer: 'ANDREA DI FRANCESCO', style: 'White IPA', points: '33' },
        { pos: '7°', beer: '2', brewer: 'MASSIMILIANO BELLINI', style: 'German Pils', points: '28.5' },
        { pos: '8°', beer: '25', brewer: 'JACOPO CORIGLIANO', style: 'Munich Helles', points: '28.5' },
        { pos: '9°', beer: '18', brewer: 'ANTONIO PALLADINI', style: 'Munich Helles', points: '20.5' },
      ],
      TAVOLO2: [
        { pos: '1°', beer: '6', brewer: 'CLAUDIO TREMENTOZZI', style: 'American Porter', points: '39', final: true },
        { pos: '2°', beer: '3', brewer: 'MATTEO MEDDA', style: 'American IPA', points: '33.5', final: true },
        { pos: '3°', beer: '12', brewer: 'DOMENICO CATRAMBONE', style: 'Belgian Dubbel', points: '32.5' },
        { pos: '4°', beer: '4', brewer: 'SIMONE CAIRONE', style: 'Munich Helles', points: '29.5' },
        { pos: '5°', beer: '5', brewer: 'TINO DE LUCA', style: 'Weissbier', points: '29.5' },
        { pos: '6°', beer: '11', brewer: 'DOMENICO CATRAMBONE', style: 'English IPA', points: '29' },
        { pos: '7°', beer: '19', brewer: 'LUCA SESTILI', style: 'German Pils', points: '28.5' },
        { pos: '8°', beer: '20', brewer: 'LUCIO DIOMEDI', style: 'Best Bitter', points: '28', mention: 'MENZIONE SPECIALE BITTER' },
        { pos: '9°', beer: '27', brewer: 'MARTINO FERRAIUOLO', style: 'Münchner Dunkel', points: '26.5' },
        { pos: '10°', beer: '13', brewer: 'DOMENICO CATRAMBONE', style: 'Saison', points: '22' },
      ],
      TAVOLO3: [
        { pos: '1°', beer: '26', brewer: 'DONATO GRAZIANO', style: 'Belgian Blond Ale', points: '37', final: true },
        { pos: '2°', beer: '17', brewer: 'FILIPPO PARICIANI', style: 'American IPA', points: '36', final: true },
        { pos: '3°', beer: '24', brewer: 'H.B. #24', style: 'Czech Amber Lager', points: '29' },
        { pos: '4°', beer: '21', brewer: 'LUCA BESSONE', style: 'German Pils', points: '29.5' },
        { pos: '5°', beer: '23', brewer: 'ANTONIO DI FRANCIA', style: 'Sweet Stout', points: '27.5' },
        { pos: '6°', beer: '10', brewer: 'DARIO PASINI', style: 'Saison', points: '25.5' },
        { pos: '7°', beer: '8', brewer: 'ANGELO CASERTA', style: 'Oatmeal Stout', points: '21' },
        { pos: '8°', beer: '16', brewer: 'FILIPPO PARICIANI', style: 'Dortmunder Export', points: '20.5' },
        { pos: '9°', beer: '28', brewer: 'MARTINO FERRAIUOLO', style: 'Rauchbier', points: '13.5' },
      ]
    },
    '2023': {
      BOS: [
        { pos: '1°', beer: '32', brewer: 'GIANCARLO DIPIERRO', style: 'Belgian Blond Ale', points: '--' },
        { pos: '2°', beer: '15', brewer: 'MARTINO FERRAIUOLO', style: 'Rauch Bier', points: '--' },
        { pos: '3°', beer: '9', brewer: 'LUCA SESTILI', style: 'Old Ale', points: '--' },
        { pos: '4°', beer: '10', brewer: 'EMILIANO D\'OVIDIO', style: 'Belgian Dark Strong Ale', points: '--' },
        { pos: '5°', beer: '29', brewer: 'DONATO GRAZIANO', style: 'Hazy IPA', points: '--' },
        { pos: '6°', beer: '8', brewer: 'EMILIANO D\'OVIDIO', style: 'Schwarzbier', points: '--' },
      ],
      TAVOLO1: [
        { pos: '1°', beer: '32', brewer: 'GIANCARLO DIPIERRO', style: 'Belgian Blond Ale', points: '--', final: true },
        { pos: '2°', beer: '10', brewer: 'EMILIANO D\'OVIDIO', style: 'Belgian Dark Strong Ale', points: '--', final: true },
        { pos: '3°', beer: '20', brewer: 'H.B. #20', style: 'Belgian Dubbel', points: '--' },
        { pos: '4°', beer: '32', brewer: 'H.B. #32', style: 'Belgian Blond Ale', points: '--' },
        { pos: '5°', beer: '2', brewer: 'H.B. #02', style: 'Belgian Dubbel', points: '--' },
        { pos: '6°', beer: '1', brewer: 'H.B. #01', style: 'Belgian Dark Strong Ale', points: '--' },
        { pos: '7°', beer: '21', brewer: 'H.B. #21', style: 'Saison', points: '--' },
        { pos: '8°', beer: '23', brewer: 'H.B. #23', style: 'Saison', points: '--' },
        { pos: '9°', beer: '34', brewer: 'H.B. #34', style: 'Saison', points: '--' },
      ],
      TAVOLO2: [
        { pos: '1°', beer: '15', brewer: 'MARTINO FERRAIUOLO', style: 'Rauch Bier', points: '--', final: true },
        { pos: '2°', beer: '8', brewer: 'EMILIANO D\'OVIDIO', style: 'Schwarzbier', points: '--', final: true },
        { pos: '3°', beer: '28', brewer: 'H.B. #28', style: 'California Common', points: '--' },
        { pos: '4°', beer: '7', brewer: 'H.B. #07', style: 'Czech Amber Lager', points: '--' },
        { pos: '5°', beer: '30', brewer: 'H.B. #30', style: 'Schwarzbier', points: '--' },
        { pos: '6°', beer: '3', brewer: 'H.B. #03', style: 'Rauch Bier', points: '--' },
        { pos: '7°', beer: '35', brewer: 'H.B. #35', style: 'Classic Style Smoked Beer', points: '--' },
        { pos: '8°', beer: '6', brewer: 'H.B. #06', style: 'Kolsh', points: '--' },
        { pos: '9°', beer: '19', brewer: 'H.B. #19', style: 'German Pils', points: '--' },
      ],
      TAVOLO3: [
        { pos: '1°', beer: '9', brewer: 'LUCA SESTILI', style: 'Old Ale', points: '--', final: true },
        { pos: '2°', beer: '29', brewer: 'DONATO GRAZIANO', style: 'Hazy IPA', points: '--', final: true },
        { pos: '3°', beer: '16', brewer: 'H.B. #16', style: 'American IPA', points: '--' },
        { pos: '4°', beer: '18', brewer: 'H.B. #18', style: 'Specialty Fruit Beer', points: '--' },
        { pos: '5°', beer: '22', brewer: 'H.B. #22', style: 'Russian Imperial Stout', points: '--' },
        { pos: '6°', beer: '25', brewer: 'H.B. #25', style: 'Alternative Sugar Beer', points: '--' },
        { pos: '7°', beer: '26', brewer: 'H.B. #26', style: 'Fruit Beer', points: '--' },
        { pos: '8°', beer: '24', brewer: 'H.B. #24', style: 'Irish Red Ale', points: '--' },
        { pos: '9°', beer: '31', brewer: 'H.B. #31', style: 'Oatmeal Stout', points: '--' },
      ]
    }
  };

  const phases = [
    { id: 'BOS', label: 'BEST OF SHOW' },
    { id: 'TAVOLO1', label: 'TAVOLO 1' },
    { id: 'TAVOLO2', label: 'TAVOLO 2' },
    { id: 'TAVOLO3', label: 'TAVOLO 3' },
  ];

  const currentYearData = allResults[activeYear] || {};
  const currentPhaseData = currentYearData[activePhase] || [];

  return (
    <section id="ranking" className="bg-black pt-12 pb-20 border-t border-zinc-900">      
      <div className="bb-container px-4">
        
        <div className="mb-12">
          <span className="uppercase tracking-[0.5em] text-[10px] font-bold text-[#c49a45] block mb-4">Official Technical Results</span>
          <h2 className="bb-display text-5xl md:text-7xl text-white uppercase leading-none font-black">RANKING <span className="text-[#c49a45]">ARENA</span></h2>
        </div>

        <div className="flex gap-4 mb-12 border-b border-zinc-900 pb-8 overflow-x-auto">
          {['2025', '2024', '2023'].map(year => (
            <button key={year} onClick={() => { setActiveYear(year); setActivePhase('BOS'); }} className={`px-6 py-2 text-xs font-black tracking-[0.3em] transition-all flex-shrink-0 ${activeYear === year ? 'bg-[#c49a45] text-black' : 'text-zinc-600 hover:text-white'}`}>
              {year}
            </button>
          ))}
        </div>

        {currentPhaseData.length > 0 ? (
          <>
            <div className="flex flex-wrap gap-2 md:gap-4 mb-8">
              {phases.map(p => (
                <button key={p.id} onClick={() => setActivePhase(p.id)} className={`px-4 py-3 text-[10px] font-bold tracking-widest border transition-all ${activePhase === p.id ? 'border-[#c49a45] text-[#c49a45] bg-[#c49a45]/5' : 'border-zinc-800 text-zinc-500 hover:border-zinc-600'}`}>
                  {p.label}
                </button>
              ))}
            </div>

            <div className="overflow-x-auto border border-zinc-900 bg-zinc-950/50">
              <table className="w-full text-left border-collapse min-w-[750px]">
                <thead>
                  <tr className="border-b border-zinc-800 bg-zinc-900/50">
                    <th className="p-5 text-[10px] font-black text-[#c49a45] uppercase tracking-widest">Rank</th>
                    <th className="p-5 text-[10px] font-black text-[#c49a45] uppercase tracking-widest">ID</th>
                    <th className="p-5 text-[10px] font-black text-[#c49a45] uppercase tracking-widest">Homebrewer</th>
                    <th className="p-5 text-[10px] font-black text-[#c49a45] uppercase tracking-widest">Stile</th>
                    <th className="p-5 text-[10px] font-black text-[#c49a45] uppercase tracking-widest text-right">Punti</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPhaseData.map((row, i) => {
                    const isPodium = activePhase === 'BOS' && i < 3;
                    return (
                      <tr 
                        key={i} 
                        className={`border-b border-zinc-900/50 hover:bg-white/5 transition-all duration-300 ${isPodium ? 'border-l-2 border-l-[#c49a45]' : ''}`}
                      >
                        <td className="p-5 w-24">
                          <span className={`font-black text-xl tracking-tighter ${isPodium ? 'text-[#c49a45]' : 'text-zinc-600'}`}>
                            {row.pos}
                          </span>
                        </td>
                        <td className="p-5 text-zinc-600 font-mono text-sm">#{row.beer.toString().padStart(2, '0')}</td>
                        <td className="p-5">
                          <div className="flex items-center gap-3">
                            <span className={`text-sm font-bold tracking-wide uppercase ${isPodium ? 'text-[#c49a45]' : 'text-white'}`}>
                              {row.brewer}
                            </span>
                            {row.final && (
                              <span className="text-[8px] bg-zinc-900 text-[#c49a45] border border-[#c49a45]/30 px-2 py-0.5 rounded-full tracking-tighter font-bold">FINALISTA</span>
                            )}
                            {row.mention && (
                              <span className="text-[8px] bg-[#c49a45] text-black px-2 py-0.5 rounded-full font-black tracking-tighter">
                                {row.mention}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="p-5 text-zinc-400 text-[11px] uppercase tracking-wider italic opacity-70">
                          {row.style}
                        </td>
                        <td className="p-5 text-right text-[#c49a45] font-mono font-bold text-base">
                          {row.points}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <p className="text-zinc-600 text-[9px] uppercase tracking-[0.2em] mt-8 text-center italic">
              {activePhase === 'BOS' 
                ? "I risultati mostrati fanno riferimento esclusivamente alle finali Best of Show."
                : "I risultati dei singoli tavoli si riferiscono alle fasi di valutazione tecnica che hanno decretato i finalisti."}
            </p>
          </>
        ) : (
          <div className="py-20 text-center border border-dashed border-zinc-900">
             <Beer className="mx-auto text-zinc-800 mb-4" size={32} />
             <p className="text-zinc-600 text-[10px] uppercase tracking-[0.3em]">Archivio {activeYear} non disponibile</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default RankingArena;